import { Link } from "react-router-dom";
import { SITE, SECTIONS } from "@/config/sections";
import { HOME } from "@/constants/testIds";
import { SectionLink } from "@/components/SectionLink";

export const Footer = () => (
  <footer data-testid={HOME.footer} className="bg-[#1C1917] text-stone-300 mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row justify-between gap-10">
      <div>
        <p className="font-heading text-2xl font-bold text-white">{SITE.name}</p>
        <p className="mt-2 text-sm text-stone-400">{SITE.domain}</p>
        <div className="mt-5 flex gap-4 text-sm">
          {SITE.socials.map((s) => (
            <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={HOME.footerSocial(s.id)} className="hover:text-[#E06D44] transition-colors">
              {s.label}
            </a>
          ))}
        </div>
      </div>
      <ul className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
        {SECTIONS.map((s) => (
          <li key={s.id}>
            <SectionLink url={s.url} data-testid={HOME.footerLink(s.id)} className="hover:text-[#E06D44] transition-colors">
              {s.title}
            </SectionLink>
          </li>
        ))}
        <li><Link to="/blog" data-testid={HOME.footerLink("blog")} className="hover:text-[#E06D44] transition-colors">Kiddee's toy tests</Link></li>
        <li><Link to="/track" data-testid={HOME.footerLink("track")} className="hover:text-[#E06D44] transition-colors">Track an order</Link></li>
        <li><Link to="/account" data-testid={HOME.footerLink("account")} className="hover:text-[#E06D44] transition-colors">My orders</Link></li>
        <li><Link to="/policies" data-testid={HOME.footerLink("policies")} className="hover:text-[#E06D44] transition-colors">Shipping, returns & contact</Link></li>
      </ul>
    </div>
    <p className="text-center text-xs text-stone-500 pb-8">© {new Date().getFullYear()} {SITE.name}</p>
  </footer>
);
